export default {
    name: 'v5-icon-qrcode',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M491.925 532.075v321.258H170.667V532.075h321.258zm105.408 257.258v64h-64v-64h64zm256-85.333v149.333h-128v-64h64V704h64zM427.925 596.075H234.667v193.258h193.258V596.075zm233.408 1.258v128h64v64h-128v-192h64zM384 640v106.667H277.333V640H384zm405.333 0v64h-64v-64h64zm64-106.667V640h-64v-42.667h-64v-64h128zm-256 0v64h-64v-64h64zM491.925 170.667v321.258H170.667V170.667h321.258zm361.408 0v321.258H532.075V170.667h321.258zm-425.408 64H234.667v193.258h193.258V234.667zm361.408 0H596.075v193.258h193.258V234.667zM384 277.333V384H277.333V277.333H384zm362.667 0V384H640V277.333h106.667z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
